import React from 'react';
import { Link } from 'react-router-dom';

import css from './SectionFounderCustom.module.css';

const SectionFounderCustom = props => {
  const { sectionId } = props;

  return (
    <section id={sectionId} className={css.root}>
      <div className={css.container}>
        <div className={css.twoCol}>
          <div className={css.imageWrapper}>
            <picture>
              <source srcSet="/images/founder-kate.webp" type="image/webp" />
              <img
                src="/images/founder-kate.jpg"
                alt="Kate, founder of Produced Near-By, with her dog on the beach"
                className={css.image}
              />
            </picture>
          </div>
          <div className={css.content}>
            <h2 className={css.title}>Hello, from founder Kate</h2>
            <p className={css.paragraph}>
              I grew up in rural Cumbria in the 1970s and 1980s.
            </p>
            <p className={css.paragraph}>
              Milk came from Tom Pearson&rsquo;s cows in the village (that&rsquo;s him, here outside
              his farmhouse, photographed by me when I was about seven). Beef came from Airey&rsquo;s
              Farm Shop on Lindale hill because they could tell my dad which field the cow had grazed
              in. Lobsters came from Stan Mulgrew on Walney Island. Meat and potato pies came from
              Greens Bakery in our town, Barrow-in-Furness.
            </p>
            <p className={css.paragraph}>
              Nowadays, knowing where you can find good local produce has become more and more
              difficult, wherever you grow up. So I created Produced Near-By to make it easier &ndash;
              a guide to the people doing it properly and how you can go and meet them.
            </p>
            <Link to="/s" className={css.ctaButton}>
              Look them up
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionFounderCustom;
